import styled from 'styled-components';

export const ProcessingContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  letter-spacing: ${props => props.theme.letterSpacing.point5};
  color: ${props => props.theme.fontColors.textColor};
  span {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    color: ${props => props.theme.fontColors.textColor};
    margin-left: 0.5rem;
  }
  justify-content: space-between;
  & > div:nth-child(1) {
    flex-direction: column;
    & > div:last-child {
      & div:nth-child(1):after {
        content: '';
        height: 0.72rem;
        width: 1px;
        background-color: black;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
      }
    }
  }
  & > div:last-child {
    align-self: center;
    span {
      letter-spacing: ${props => props.theme.letterSpacing.point6};
    };
  }

  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
    & > div:nth-child(1) {
      & > div:last-child {
        flex-direction: column;
        & div:nth-child(1) {
          margin-bottom: 1.25rem;
          &:after {
            display: none;
          }
        }
      }
    }
    & > div:last-child {
      align-self: start;
    }
  }
`;
